import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { BoxService } from 'src/app/service/box.service';
import { MovimentacaoService } from 'src/app/service/movimentacai.service';
import { Box } from '../box/box';
import { Movimentacao } from './movimentacao';

@Component({
  selector: 'app-movimentacao-form',
  templateUrl: './movimentacao-form.component.html',
  styleUrls: ['./movimentacao.component.scss'],
})
export class MovimentacaoFormComponent implements OnInit {

  formulario: FormGroup;
  boxsAtivo: Box[] = [];
  caixaOrigen: any;
  caixaDestino: any;

  constructor(
    private boxService: BoxService,
    private movimentacaoService: MovimentacaoService,
    private formBilder: FormBuilder,
    private snackBar: MatSnackBar,
    private router: Router,
  ) { }

  ngOnInit(): void {
    this.montarFormulario();
    this.listarBoxAtivo();
  }

  submit() {
    const formValues = this.formulario.value;

    const movimentacao: Movimentacao = new Movimentacao(
      formValues.id,
      formValues.observacao,
      formValues.tipoMovimentacao,
      this.caixaOrigen,
      this.caixaDestino,
      formValues.valorMovimentacao,
      formValues.contaOrigemDescricao,
      formValues.contaDestinoDescricao);

    this.movimentacaoService.save(movimentacao).subscribe(() => {
      this.snackBar.open('Movimentação salvo com sucesso!', 'Sucesso', {
        duration: 2000
      });
      this.limparFormulario();
      this.voltarConsulta();
    }, errorResponse => {
      this.snackBar.open(errorResponse.error.message, 'ERRO', {
        duration: 2000
      });
    });
  }

  montarFormulario() {
    this.formulario = this.formBilder.group({
      id: [null, Validators.nullValidator],
      observacao: [null, [Validators.minLength(3), Validators.maxLength(250)]],
      tipoMovimentacao: [null, Validators.nullValidator],
      contaOrigem: [null, Validators.nullValidator],
      contaDestino: [null],
      valorMovimentacao: [null, Validators.nullValidator],
      contaOrigemDescricao: [null],
      contaDestinoDescricao: [null]
    });
    this.caixaDestino = '';
  }

  limparFormulario() {
    this.formulario.reset();
    this.caixaDestino = null;
    this.caixaOrigen = null;
  }

  listarBoxAtivo() {
    this.boxService.listarBoxAtivo().subscribe((response) => {
      this.boxsAtivo = response;
    });
  }

  voltarConsulta() {
    this.router.navigate(['/movimentacao/consulta']);
  }
}
